<template>
	<div class="messages">
		<div class="row">
			<div class="col-5 mb-4">
				<h1>{{ $t("change-log") }}</h1>
			</div>
		</div>
		<ScrollPaginator
            :data="updates"
            :submitting="submitting"
            :filters="filters"
            @toPage="toPage"
        >
            <template v-slot:item="{ item }">
                <div class="list-group">
                <div class="list-group-item" >
                    <h3><strong>{{ item.title }}</strong></h3>
                    <p>CAFS v{{ item.version }}. {{$t('publication-date')}} {{ $datetime.getLocaleStringFromTimeStamp(item.datetime) }}</p>
                    <p>{{ item.description }} </p>
                </div>
            </div>
			</template>
		</ScrollPaginator>
		
	</div>
</template>

<script>
import ScrollPaginator from "src/components/Table/ScrollPaginator.vue";

export default {
	components: {
		ScrollPaginator,
	},
	data() {
		return {
			updates:[],
            filters: {
                page: 1,
                page_size : 15
            },
            submitting: true        
		};
	},
	mounted() {
        this.getChangelog();
	},
	methods: {
        getChangelog() {
            this.$cfetch(`${this.$settings.APIBaseURL}/changelog/list`, {
				method: "post",
				data: this.filters,
			})
			.then((res) => {
				if (res.status === "SUCCESS") {
					this.updates = res.results;
                    this.filters = res.pagination;
                    this.submitting = false;
				}
			})
			.catch((error) => {
                console.log(error)
				this.$log.error.call(this, error);
			});
        },

        toPage(pageNo) {
            this.filters.page = pageNo
            this.getChangelog()
        }
		
	},
};
</script>
